export default "__VITE_ASSET__c6da0505__"